import styled from 'styled-components';

import {font} from 'theme';

export const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const ModalMessage = styled.p`
    margin: 0;
    font-family: ${font.family.primary};
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0;
    text-align: center;
`;

export const ModalButtons = styled.div`
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    margin-top: 10px;
`;
